import React from 'react';
import { ROUTE_KEYS } from 'utils/constants';
import AuthRoute from './AuthRoute';
import UnauthRoute from './UnauthRoute';
import Login from '../pages/auth/login';
import Dashboard from '../pages/dashboard';
import { createBrowserRouter, RouteObject } from 'react-router-dom';
import DashboardLayout from 'layouts/dashboard.layout';
import Home from 'pages/home';
import Deals from 'pages/deals';
import PushNotifications from 'pages/push-notifications';
import Trash from 'pages/trash';
import CreatePostLayout from 'layouts/create-post.layout';
import CreatePostIndex from 'pages/home/create-post';
import CreatePostDetails from 'pages/home/create-post/create-post-details';
import CreatePostTimeline from 'pages/home/create-post/create-post-timeline';
import EditPostIndex from 'pages/home/edit-post';
import EditPostDetails from 'pages/home/edit-post/edit-post-details';
import EditPostTimeline from 'pages/home/edit-post/edit-post-timeline';
import EditPostLayout from 'layouts/edit-post.layout';
import CreateDealLayout from 'layouts/create-deal.layout';
import CreateDealIndex from 'pages/deals/create-deal';
import CreateDealDetails from 'pages/deals/create-deal/create-deal-details';
import CreateDealTimeline from 'pages/deals/create-deal/create-deal-timeline';
import CreateDealSettings from 'pages/deals/create-deal/create-deal-settings';
import ExplorePage from 'pages/explore';
import EditDealLayout from 'layouts/edit-deal.layout';
import EditDealIndex from 'pages/deals/edit-deal';
import EditDealDetails from 'pages/deals/edit-deal/edit-deal-details';
import EditDealSettings from 'pages/deals/edit-deal/edit-deal-settings';
import EditDealTimeline from 'pages/deals/edit-deal/edit-deal-timeline';
import PhotoContentUpload from 'pages/explore/photo-content-upload';
import ExploreContextProvider from 'contexts/explore.context';
import VideoContentUpload from 'pages/explore/video-content-upload';

const CREATE_POST_ROUTES = [
  {
    index: true,
    element: <CreatePostIndex />
  },
  {
    path: ROUTE_KEYS.CREATE_POST_DETAILS,
    element: <CreatePostDetails />
  },
  {
    path: ROUTE_KEYS.CREATE_POST_TIMELINE,
    element: <CreatePostTimeline />
  }
];

const CREATE_DEAL_ROUTES = [
  {
    index: true,
    element: <CreateDealIndex />
  },
  {
    path: ROUTE_KEYS.CREATE_DEAL_DETAILS,
    element: <CreateDealDetails />
  },
  {
    path: ROUTE_KEYS.CREATE_DEAL_SETTINGS,
    element: <CreateDealSettings />
  },
  {
    path: ROUTE_KEYS.CREATE_DEAL_TIMELINE,
    element: <CreateDealTimeline />
  }
];

const EDIT_POST_ROUTES = [
  {
    index: true,
    element: <EditPostIndex />
  },
  {
    path: ROUTE_KEYS.EDIT_POST_DETAILS,
    element: <EditPostDetails />
  },
  {
    path: ROUTE_KEYS.EDIT_POST_TIMELINE,
    element: <EditPostTimeline />
  }
];

const EDIT_DEAL_ROUTES = [
  {
    index: true,
    element: <EditDealIndex />
  },
  {
    path: ROUTE_KEYS.EDIT_DEAL_DETAILS,
    element: <EditDealDetails />
  },
  {
    path: ROUTE_KEYS.EDIT_DEAL_SETTINGS,
    element: <EditDealSettings />
  },
  {
    path: ROUTE_KEYS.EDIT_DEAL_TIMELINE,
    element: <EditDealTimeline />
  }
];

const CREATE_CONTENTS_ROUTES = [
  {
    index: true,
    element: <ExplorePage />
  },
  {
    path: ROUTE_KEYS.PHOTO_CONTENT,
    element: <PhotoContentUpload />
  },
  {
    path: ROUTE_KEYS.VIDEO_CONTENT,
    element: <VideoContentUpload />
  }
];

const DASHBOARD_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Dashboard />
  },
  {
    path: ROUTE_KEYS.HOME,
    element: <Home />
  },
  {
    path: ROUTE_KEYS.DEALS_AND_DISCOUNTS,
    element: <Deals />
  },
  {
    path: ROUTE_KEYS.PUSH_NOTIFICATIONS,
    element: <PushNotifications />
  },
  {
    path: ROUTE_KEYS.TRASH,
    element: <Trash />
  },
  {
    path: ROUTE_KEYS.EMAILS,
    element: <Trash />
  },
  {
    path: ROUTE_KEYS.EXPLORE,
    element: <ExploreContextProvider />,
    children: CREATE_CONTENTS_ROUTES
  },
  {
    path: ROUTE_KEYS.CREATE_POST,
    element: <CreatePostLayout />,
    children: CREATE_POST_ROUTES
  },
  {
    path: ROUTE_KEYS.CREATE_DEAL,
    element: <CreateDealLayout />,
    children: CREATE_DEAL_ROUTES
  },
  {
    path: ROUTE_KEYS.EDIT_POST,
    element: <EditPostLayout />,
    children: EDIT_POST_ROUTES
  },
  {
    path: ROUTE_KEYS.EDIT_DEAL,
    element: <EditDealLayout />,
    children: EDIT_DEAL_ROUTES
  }
];

const ALL_ROUTES: RouteObject[] = [
  {
    path: ROUTE_KEYS.LOGIN,
    element: (
      <UnauthRoute>
        <Login />
      </UnauthRoute>
    )
  },
  {
    path: ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: DASHBOARD_ROUTES
  },
  {
    path: '*',
    element: (
      <UnauthRoute>
        <Login />
      </UnauthRoute>
    )
  }
];

export default createBrowserRouter(ALL_ROUTES);
